// src/components/common/SimpleNavbar.js
import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const SimpleNavbar = () => {
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          component={RouterLink}
          to="/"
          sx={{
            flexGrow: 1,
            textDecoration: 'none',
            color: 'inherit',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box component="img" src="/logo.png" alt="Logo" sx={{ height: 40, mr: 1, display: { xs: 'none', sm: 'block' } }} />
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default SimpleNavbar;
